import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "vuex";
  import { reactive, computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, requiredIf } from "@vuelidate/validators";
  import Modal from "@/components/ui/Modal.vue";
  import FormModalLayout from "./FormModalLayout.vue";
  import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import DatePicker from "@/components/ui/DatePicker.vue";
  import { TypeOfOption } from "@/enums/TypeOfOption";
  import Cleave from "vue-cleave-component";
  import plural from "@/features/plural";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import { formatDateCalendar } from "@/helpers/date";
  import { useToast } from "vue-toastification";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOptionModal',
  props: {
    isOpen: {
      required: true,
      type: Boolean,
    },
    listForUpdate: {
      required: true,
      type: Array,
    },
    registrationDate: {
      required: true,
      type: String,
      default: "",
    },
  },
  emits: ["close", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const dayjs = require("dayjs");
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");

  dayjs.extend(isSameOrBefore);

  const store = useStore();
  const emits = __emit;
  const props = __props;
  const regDate = ref(false);

  const optionPrice = {
    numeral: true,
    numeralThousandsGroupStyle: "thousand",
  };

  const types = computed(() => {
    return Object.values(TypeOfOption).map((x, ind) => {
      return {
        label: x,
        value: x,
      };
    });
  });

  const registrationDateFormated = computed(() => {
    if (!props.registrationDate) {
      return "";
    } else return formatDateCalendar(props.registrationDate);
  });

  const form = reactive({
    type: types.value[0].value,
    holder: "",
    startDate: dayjs(),
    endDate: "",
    price: "",
    fee: "",
    percent: 0,
    conditions: "",
  });
  const rules = {
    type: { required },
    holder: { required },
    startDate: { required },
    endDate: {
      required: requiredIf(() => !regDate.value),
      valid: () => {
        if (!form.endDate || !form.startDate) {
          return true;
        } else {
          return dayjs(form.startDate).isSameOrBefore(dayjs(form.endDate));
        }
      },
    },
    price: { required },
    fee: { required },
  };
  const v$ = useVuelidate(rules, form, { $lazy: true });

  const selectedType = computed(() => {
    const t = types.value.find((x) => x.value === form.type);

    return t;
  });
  const persent = computed(() => {
    const price = Number(form.price);
    const fee = Number(form.fee);
    const pers = fee / (price / 100);

    return Math.round(pers * 100) / 100;
  });
  const inputIndent = computed(() => {
    if (!form.fee) {
      return "left: 0";
    } else {
      return "left:" + (form.fee.length * 11 + 35) + "px";
    }
  });
  const idLotsList = computed(() => {
    return props.listForUpdate.map((item) => item.id);
  });

  function check(value: boolean) {
    regDate.value = value;
    form.endDate = "";
  }

  const createPutAndCallObj = () => {
    return {
      lotIds: idLotsList.value,
      option: {
        typeOfOption: form.type,
        optionHolder: form.holder,
        termsOfOption: {
          optionStartDate: form.startDate,
          optionEndDate: form.endDate || "Registration Date",
          landPrice: Number(form.price),
          optionFee: {
            fee: Number(form.fee),
            percent: persent.value,
          },
          conditions: !form.conditions ? "No conditions" : form.conditions,
        },
      },
    };
  };

  function save() {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    const data = createPutAndCallObj();

    close();
    emits("loading");
    store
      .dispatch("lot/updateLotStatusOption", data)
      .then(() => {
        close(true);
      })
      .catch((error) => {
        const message = error?.response?.data?.message;

        toast.error(message || "Something went wrong");
      });
  }

  function close(update = false) {
    emits("close", update);
    clearForm();
    resetVuelidateErrors(v$);
    regDate.value = false;
  }

  function clearForm() {
    Object.assign(form, {
      type: types.value[0].value,
      holder: "",
      startDate: dayjs(),
      endDate: "",
      price: "",
      fee: "",
      percent: 0,
      conditions: "",
    });
  }

const __returned__ = { toast, dayjs, isSameOrBefore, store, emits, props, regDate, optionPrice, types, registrationDateFormated, form, rules, v$, selectedType, persent, inputIndent, idLotsList, check, createPutAndCallObj, save, close, clearForm, get useStore() { return useStore }, reactive, computed, ref, get useVuelidate() { return useVuelidate }, get required() { return required }, get requiredIf() { return requiredIf }, Modal, FormModalLayout, CheckboxInput, DropDown, DatePicker, get TypeOfOption() { return TypeOfOption }, get Cleave() { return Cleave }, get plural() { return plural }, get resetVuelidateErrors() { return resetVuelidateErrors }, get formatDateCalendar() { return formatDateCalendar }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})